import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface ListProps {
  $tone?: 'alt';
  $size?: 'xsmall' | 'small';
}

export const List = styled.ul<ListProps>`
  --separator-size: ${size(0.5)};
  --separator-spacing: ${size(1)};

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
  color: currentColor;
  ${({ $tone }) =>
    $tone === 'alt'
      ? css`
          color: var(--c-text-muted);
        `
      : undefined}
  ${({ $size }) =>
    $size === 'xsmall'
      ? css`
          --separator-size: ${size(0.375)};
          --separator-spacing: ${size(0.75)};

          font-size: ${(props) => props.theme.font.size.xsmall};
        `
      : $size === 'small'
        ? css`
            font-size: ${(props) => props.theme.font.size.small};
          `
        : undefined};
`;

export const Item = styled.li`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    &::after {
      content: '';
      flex-shrink: 0;
      width: var(--separator-size);
      height: var(--separator-size);
      margin: 0 var(--separator-spacing);
      border-radius: 50%;
      background-color: currentColor;
    }
  }
`;
